module.exports = "<edit-header></edit-header>\n\n<div class=\"edit-admin\">\n    <edit-userexport></edit-userexport>\n    <hr>\n    <edit-roleexport></edit-roleexport>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.html
// module id = ./src/app/admin/admin.component.html
// module chunks = main